import api from "../../../services/api";

const APIS = {

  MY_ASSIGNMENTS_DATA: "/Sample/getMyAssignments",
  UPDATE_MY_ASSIGNMENTS_DATA: "/Sample/UpdateMyAssignments",
  REMOVE_MY_ASSIGNMENT_DATA: "/Scheduler/unassign-samples",
  REPORTS_EXPORT: "/Reports/exportsamples",

  UPDATE_PEER_REVIEW_DATA: "/SampleStatus/updatePeerReviewStatus",
  PEER_REVIEW_POST_DATA: "/Sample/peer-review-samples",
};

//_________MY ASSIGNMENT APIs______________//

export const getMyAssignmentsData = async (payload) => {
  try {
    const response = await api.post(APIS.MY_ASSIGNMENTS_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching My Assignments data:", error);
    throw error;
  }
};
export const unassignSamples = async (payload) => {
    try {
        const response = await api.post(APIS.REMOVE_MY_ASSIGNMENT_DATA, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const updateMyAssignmentsData = async (payload) => {
  try {
    const response = await api.post(APIS.UPDATE_MY_ASSIGNMENTS_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching My update Assignments data:", error);
    throw error;
  }
};
export const exportReports = async (params) => {
  try {
    const response = await api.get(APIS.REPORTS_EXPORT, {
      params,
      paramsSerializer: (params) => {
        return Object.keys(params)
          .map((key) =>
            Array.isArray(params[key])
              ? params[key].map((val) => `${key}=${encodeURIComponent(val)}`).join("&")
              : `${key}=${encodeURIComponent(params[key])}`
          )
          .join("&");
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting Reports data:", error);
    throw error;
  }
};

//___________PEER REVIEW_____________//

export const getPeerReviewData = async (payload) => {
  try {
    const response = await api.post(APIS.PEER_REVIEW_POST_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Peer Review data:", error);
    throw error;
  }
};
export const acceptPeerReview = async (payload) => {
  try {
    const response = await api.post(APIS.UPDATE_PEER_REVIEW_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Updated Peer Review accepted data:", error);
    throw error;
  }
};
